interface Product {
  name?: string;
  brand?: string;
  variant?: string;
  position?: number;
  url?: string;
  image_url: string | null | undefined;
}

function extractProductInformationFromTextDescription(
  categoryNameElement: HTMLDivElement
) {
  const textContent =
    categoryNameElement.textContent?.replace(/\r?\n|\r/g, "") || "";
  const matchesWithStyleName = textContent.match(
    /(.+)\s+in\s+(.+)\s+by\s+(.+)/
  );
  const matchesWithNoStyleName = textContent.match(/(.+)\s+by\s+(.+)/);

  if (matchesWithStyleName) {
    return {
      name: matchesWithStyleName[1]?.trim(),
      variant: matchesWithStyleName[2]?.trim(),
      brand: matchesWithStyleName[3]?.trim(),
    };
  } else if (matchesWithNoStyleName) {
    return {
      name: matchesWithNoStyleName[1]?.trim(),
      brand: matchesWithNoStyleName[2]?.trim(),
    };
  } else {
    return {};
  }
}

function extractImageUrlFromElement(categoryNameElement: HTMLDivElement) {
  const rawSrc = categoryNameElement.parentElement?.parentElement?.querySelector(
    "img"
  )?.src;

  // Exclude data urls
  if (rawSrc?.indexOf("data:") === 0) {
    return null;
  }

  return rawSrc;
}

function extractProductFromElement(categoryNameElement: HTMLDivElement) {
  if (categoryNameElement == null) {
    return;
  }

  const url = categoryNameElement.querySelector("a")?.href;

  return {
    ...extractProductInformationFromTextDescription(categoryNameElement),
    url,
    image_url: extractImageUrlFromElement(categoryNameElement),
  };
}

export function extractProductsFromProductsList(
  container?: HTMLElement
): Product[] {
  const productElements = container?.querySelectorAll<HTMLDivElement>(
    ".category_name"
  );

  if (productElements == null) {
    return [];
  }

  const result: Product[] = [];

  productElements.forEach((elem, index) => {
    const extracted = extractProductFromElement(elem);
    if (extracted == null) {
      return;
    }
    const item = { ...extracted, position: index };
    result.push(item);
  });

  return result;
}
